import { render, staticRenderFns } from "./GeneralHolidays.vue?vue&type=template&id=88563d70&scoped=true"
import script from "./GeneralHolidays.vue?vue&type=script&lang=js"
export * from "./GeneralHolidays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88563d70",
  null
  
)

export default component.exports